<template>
  <div id="question-detail" v-scroll-load-more="loadMoreMessage">
    <!-- 问题内容 -->
    <div class="quiz" v-loading="getDetailLoading">
      <div class="quiz-title">
        <div class="title-icon"></div>
        <div class="title-text">{{ getQuestionDetail.topic }}</div>
      </div>
      <div class="quiz-date">
        <div class="quiz-date-left">
          <div class="question-time"><span>提问时间</span><span>{{ createdTime }}</span></div>
          <div class="answer-time"><span v-show="solvedTime !== ''">解答时间</span><span>{{ solvedTime }}</span></div>
        </div>
        <div class="quiz-date-right">
          <!-- 已回答 -- 已归档，这个区间算为解决中 -->
          <div class="solving" v-show="getQuestionDetail.status === 1"><i class="icon-solving"></i>解决中</div>
        </div>
      </div>
      <div class="quiz-detail">
        <div class="detail-icon">描述</div>
        <div class="detail-content">
          <div class="detail-text">
            <!-- 使用 pre 来识别字段中的换行符 -->
            <pre>{{ getQuestionDetail.description }}</pre>
          </div>
          <!-- 问题详情图片 -->
          <ul v-if="getQuestionDetail.attachments.length !== 0"
              class="annex-list image-view">
            <li v-for="(source, index) in previewImgList"
                class="annex-item"
                @click="handlerPreview(source)"
                :key="index">
              <img :src="source.src">
              <i v-if="source.type === 'player'" class="icon-player-pause"></i>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 提交评论 -->
    <div class="reply" ref="mainReply">
      <div class="reply-input">
        <at :members="members" name-key="name" v-model="messageContent">
          <template slot="item" slot-scope="s">
            <img class="avatar" :src="s.item.avatar" width="17" height="17" style="padding-right: 8px">
            <span v-text="s.item.name"></span>
          </template>
          <div ref="messageTextarea" class="editor" :style="editorWidth" contenteditable="true" @paste="pastePicture"></div>
        </at>
      </div>
      <div class="submit">
        <div class="upload-wrap">
          <div class="upload" @click="openPictureCard">上传图片</div>
          <div class="picture-count" v-show="getPictureCount !== 0">共{{ getPictureCount }}张</div>
        </div>
        <div class="submit-input" @click="submitMessage" v-loading="isSubmitMessage">
          <div>评论</div>
        </div>
      </div>
      <picture-card :fileList="fileList" v-show="isPictureCard" @deleteFile="deleteFile" @inputChange="inputChange"></picture-card>
    </div>
    <!-- 评论列表 -->
    <comment-list
      v-loading="getMessageLoading"
      :isLoadingMore="isLoadingMore"
      @handler_withdraw="handler_withdraw"></comment-list>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex'
import {formatFileMixin, fetchUploadFileMixin} from '../../mixins/format-file'
import At from '../at/At'
import commentList from '../comment-list/comment-list'
import pictureCard from '../picture-card/picture-card'
import Viewer from 'v-viewer/src/component'
import scrollLoadMore from '../../directives/scroll-load-more/index'

export default {
  name: 'questionDetail',
  mixins: [formatFileMixin, fetchUploadFileMixin],
  props: {
    label: Number
  },
  data () {
    return {
      imageAddress: 'https://www.erplus.co/image',
      MAX_FILE_LEN: 12,
      isPictureCard: false,
      messageContent: '',
      fileList: [],
      previewPhoto: [],
      isAtWaiter: false,
      members: [{
        avatar: 'https://www.erplus.co/image//48/1717/11560/6bcc/47d5b7fb5263da1862fa.png',
        name: '小管子'
      }],
      currentPage: 0,
      isAllMessage: false,
      getMessageSuccess: true,
      isLoadingMore: false,
      editorWidth: {
        width: '460px'
      },
      isSubmitMessage: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.mainReply) {
        let parentWidth = this.$refs.mainReply.offsetWidth
        this.editorWidth.width = parentWidth * 0.95 + 'px'
      }

      // 避免复制富文本（显示纯文本）
      let editor = document.getElementsByClassName('editor')[0]
      try {
        document.execCommand('AutoUrlDetect', false, false)
      } catch (e) {}

      editor.addEventListener('paste', function (e) {
        e.preventDefault()
        var text = null

        if(window.clipboardData && clipboardData.setData) {
          // IE
          text = window.clipboardData.getData('text')
        } else {
          text = (e.originalEvent || e).clipboardData.getData('text/plain')
        }
        if (document.body.createTextRange) {
          if (document.selection) {
            textRange = document.selection.createRange()
          } else if (window.getSelection) {
            sel = window.getSelection()
            var range = sel.getRangeAt(0)

            // 创建临时元素，使得TextRange可以移动到正确的位置
            var tempEl = document.createElement("span")
            tempEl.innerHTML = "&#FEFF;"
            range.deleteContents()
            range.insertNode(tempEl)
            textRange = document.body.createTextRange()
            textRange.moveToElementText(tempEl)
            tempEl.parentNode.removeChild(tempEl)
          }
          textRange.text = text
          textRange.collapse(false)
          textRange.select()
        } else {
          // Chrome之类浏览器
          document.execCommand('insertText', false, text)
        }
      }, true)
    })
  },
  updated () {
    this.$nextTick(() => {
      if (this.$refs.mainReply) {
        let parentWidth = this.$refs.mainReply.offsetWidth
        this.editorWidth.width = parentWidth * 0.95 + 'px'
      }
    })
  },
  components: {
    commentList,
    pictureCard,
    At,
    Viewer
  },
  computed: {
    ...mapGetters([
      'getQuestionDetail',
      'getDetailLoading',
      'getMessageLoading',
      'getCommentPageSize',
      'getMessageDetail',
      'getQuestionPage'
    ]),
    previewImgList () {
      let imgList = []
      if (this.getQuestionDetail.attachments.length !== 0) {
        imgList = this.getQuestionDetail.attachments.map(item => {
          const obj = {
            src: item.includes(',') ? this.imageAddress + item.split(',')[0] : this.imageAddress + item,
            type: item.includes(',') ? 'player' : 'photo',
            playerCode: item.includes(',') ? item.split(',')[1] : ''
          }
          return obj
        })
        return imgList
      }
      return imgList
    },
    getPreviewSrc () {
      if (this.getQuestionDetail.attachments.length !== 0) {
        return this.getQuestionDetail.attachments.filter(attach => !attach.includes(',')).map(attach => this.imageAddress + attach)
      }
      return []
    },
    getPictureCount () {
      return this.fileList.length
    },
    createdTime () {
      return this.getQuestionDetail.createdTime ? this.getQuestionDetail.createdTime.replace(/\-/g, "\/").substr(2) : ''
    },
    solvedTime () {
      return this.getQuestionDetail.solvedTime ? this.getQuestionDetail.solvedTime.replace(/\-/g, "\/").substr(2) : ''
    },
    messageTextarea () {
      return this.$refs.messageTextarea
    }
  },
  methods: {
    ...mapMutations([
      'setImgForPreview',
      'SET_VIDEO_DIALOG'
    ]),
    ...mapActions([
      'action_addQuestionMessage',
      'action_getQuestionDetails',
      'action_getQuestionMessagePage',
      'action_cancelQuizFeedback',
      'setMessageDetail',
      'setDetailLoading',
      'setMessageLoading',
      'setQuestionPage'
    ]),
    handlerOpenPlayer (src) {
      this.SET_VIDEO_DIALOG({videoId: src.split('.')[0]});
    },
    handlerPreview (source) {
      if (source.type === 'player') {
        this.handlerOpenPlayer(source.playerCode)
      } else {
        this.handlerPreviewImg(source.src);
      }
    },
    handlerPreviewImg (src) {
      this.setImgForPreview({
        imgSrcNeedToPreview: this.getPreviewSrc,
        currImgNeedToPreview: src,
        needShowImgPreviewCommon: true
      })
    },
    pastePicture (e) {
      if (this.fileList.length === this.MAX_FILE_LEN) {
        this.$message.warning(`最多上传${this.MAX_FILE_LEN}张图片`)
        return
      }
      /* eslint-disable one-var */
      var clipboardData = e.clipboardData,
        i = 0,
        items, item, types

      if (clipboardData) {
        items = clipboardData.items
        if (!items) {
          return
        }

        item = items[0]
        // 保存在剪贴板中的数据类型
        types = clipboardData.types || []

        for (; i < types.length; i++) {
          if (types[i] === 'Files') {
            item = items[i]
            if (item && item.kind === 'file' && item.type.match(/^image\//i)) {
              // 读取该图片
              e.preventDefault()
              this.imgReader(item)
              this.isPictureCard = true
            }
          }
        }
      }
    },
    imgReader (item) {
      if (this.fileList.length === this.MAX_FILE_LEN) {
        return
      }
      var blobFile = item.getAsFile()
      var picFile = new File([blobFile], 'image.png', {type: 'image/png'}) // 将blob数据 转为file对象

      var reader = new FileReader()
      // 读取文件
      reader.onload = (e) => {
        var src = e.target.result
        this.fileList.push({file: picFile, src: src, isUploaded: false})
      }
      reader.readAsDataURL(blobFile)
    },
    submitMessage () {
      if (this.isSubmitMessage) {
        return
      }
      this.messageContent = this.$refs.messageTextarea.innerText.replace(/(^\s*)|(\s*$)/g, '')
      let self = this
      let params = null
      let commentParams = {
        quizId: self.getQuestionDetail.id,
        currentPage: 0,
        pageSize: self.getCommentPageSize
      }
      if (this.fileList.length !== 0) {
        self.isSubmitMessage = true

        this.fetchUploadPicture(this.fileList, function () {
          let fileCode = self.formatFileArrayToString(self.fileList).join(',')    //此处必须要将附件图片连接为字符串并用','分隔
          self.fileList = []
          self.isPictureCard = false
          // 单图片params
          params = {
            quizId: self.getQuestionDetail.id,
            type: 1,
            fileCode: fileCode,
            isAt: 0
          }
          if (self.messageContent !== '') {
            // 图文params
            let isAt = self.messageContent.indexOf('@小管子')
            isAt = isAt !== -1 ? 1 : 0
            params.isAt = isAt
            params.type = 3
            params.message = self.messageContent
          }
          self.action_addQuestionMessage(params).then(res => {
            self.isSubmitMessage = false
            if (res.erpCode === '000') {
              // 添加评论成功，手动给问题添加已评论数
              let newQuestionPage = self.getQuestionPage.map(item => {
                if (item.id === self.getQuestionDetail.id) {
                  if (item.isAddMessage && item.isAddMessage !== 0) {
                    item.isAddMessage += 1
                  } else {
                    item.isAddMessage = 0
                  }
                }
                return item
              })
              self.setQuestionPage(newQuestionPage)

              self.setMessageLoading(true)
              self.action_getQuestionMessagePage(commentParams).then(res => {
                self.setMessageLoading(false)
                if (res.erpCode === '000') {
                  self.setMessageDetail(res.erpData.pageItem)
                } else {
                  self.showMessage(res.erpMsg || '获取评论列表出错')
                }
              })
              self.messageContent = ''
              return '发布成功'
            } else {
              self.showMessage(res.erpMsg || '评论出错')
            }
          })
        })
      } else {
        if (this.messageContent !== '') {
          let messageLength = this.messageContent.length
          if (messageLength > 2000) {
            this.$message({
              type: 'warning',
              message: '评论字数不能超过2000',
              showClose: true
            })
            return
          }
          let isAt = this.messageContent.indexOf('@小管子')
          isAt = isAt !== -1 ? 1 : 0
          // 单文字params
          params = {
            quizId: this.getQuestionDetail.id,
            message: this.messageContent,
            type: 0,
            isAt: isAt
          }
          self.isSubmitMessage = true
          self.setMessageLoading(true)
          this.action_addQuestionMessage(params).then(res => {
            // 添加评论成功，手动给问题添加已评论数
            let newQuestionPage = self.getQuestionPage.map(item => {
              if (item.id === self.getQuestionDetail.id) {
                if (item.isAddMessage && item.isAddMessage !== 0) {
                  item.isAddMessage += 1
                } else {
                  item.isAddMessage = 1
                }
              }
              return item
            })
            self.setQuestionPage(newQuestionPage)

            self.isSubmitMessage = false
            self.setMessageLoading(false)
            if (res.erpCode === '000') {
              self.setMessageLoading(true)
              self.action_getQuestionMessagePage(commentParams).then(res => {
                self.setMessageLoading(false)
                if (res.erpCode === '000') {
                  self.setMessageDetail(res.erpData.pageItem)
                } else {
                  self.showMessage(res.erpMsg || '获取评论出错')
                }
              })
              this.messageContent = ''
              return '发布成功'
            } else {
              this.showMessage(res.erpMsg || '评论出错')
            }
          })
        } else {
          this.$message({
            type: 'warning',
            message: '评论内容不得为空',
            showClose: true
          })
        }
      }
      this.$refs.messageTextarea.innerText = ''
    },
    handler_withdraw(id) {
      let params = {id}
      this.action_cancelQuizFeedback(params).then(res => {
        if (res.erpCode === '000') {
          this.$message({
            showClose: true,
            message: '撤回成功',
            type: 'success'
          })
          this.initMessageList()
        } else {
          let msg = res.erpMsg || '撤回失败'
          this.$message({
            showClose: true,
            message: msg,
            type: 'warning'
          })
        }
      })
    },
    initMessageList() {
      let commentParams = {
        quizId: this.getQuestionDetail.id,
        currentPage: 0,
        pageSize: this.getCommentPageSize
      }
      this.setMessageLoading(true)
      this.action_getQuestionMessagePage(commentParams).then(res => {
        this.setMessageLoading(false)
        if (res.erpCode === '000') {
          this.setMessageDetail(res.erpData.pageItem)
        } else {
          let msg = res.erpMsg || '获取评论列表失败'
          this.$message({
            showClose: true,
            message: msg,
            type: 'error'
          })
        }
      })
    },
    openPictureCard () {
      this.isPictureCard = !this.isPictureCard
    },
    addPicture () {
      this.$refs.fileInput.click()
    },
    deleteFile (index) {
      this.fileList.splice(index, 1)
    },
    inputChange (event) {
      var length = event.target.files.length
      if (this.fileList.length + length > this.MAX_FILE_LEN) {
        this.$message({
          showClose: true,
          message: `最多上传${this.MAX_FILE_LEN}张图片`,
          type: 'warning'
        })
        return
      }
      var imageOnLoadPromiseArr = []
      for (var i = 0; i < length; i++) {
        let file = event.target.files[i]
        if (file === undefined) {
          break
        }
        var isImg = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg'
        if (!isImg) {
          // this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
          this.$message({
            type: 'warning',
            message: '上传图片只能是 JPG、jpeg、gif 或 PNG 格式!',
            showClose: true
          })
          return
        }
        imageOnLoadPromiseArr.push(
          new Promise(resolve => {
            var fr = new FileReader()
            fr.onload = function (e) {
              var src = e.target.result
              resolve({src, file})
            }
            fr.readAsDataURL(file)
          }))
      }
      Promise.all(imageOnLoadPromiseArr)
        .then(results => {
          results.forEach((res) => {
            this.fileList.push({file: res.file, src: res.src, isUploaded: false})
          })
        })
        .then(() => {
          event.target.value = ''
        })
    },
    loadMoreMessage () {
      if (this.isAllMessage || !this.getMessageSuccess) {
        return
      }
      if (this.getMessageDetail.length && this.getMessageDetail.length >= this.getCommentPageSize) {
        // 只在评论数超过20（即每次加载量）才显示【加载中 ...】
        this.isLoadingMore = true
      }
      this.getMessageSuccess = false
      this.currentPage += 1
      let params = {
        quizId: this.getQuestionDetail.id,
        currentPage: this.currentPage,
        pageSize: this.getCommentPageSize
      }
      this.action_getQuestionMessagePage(params).then(res => {
        this.isLoadingMore = false
        if (res.erpCode === '000') {
          this.getMessageSuccess = true
          this.isAllMessage = res.erpData.itemCount < this.getCommentPageSize
          let messageArr = []
          // let pageItem = res.erpData.pageItem
          messageArr.push(...this.getMessageDetail, ...res.erpData.pageItem)
          this.setMessageDetail(messageArr)
        } else {
          this.getMessageSuccess = true
          this.currentPage -= 1
          this.$message({
            type: 'error',
            message: res.erpMsg || '请求出错',
            showClose: true
          })
        }
      }).catch(error => {
        this.isLoadingMore = false
        this.getMessageSuccess = true
        this.currentPage -= 1
        this.$message({
          type: 'error',
          message: '请求出错',
          showClose: true
        })
      })
    },
  },
  directives: {
    scrollLoadMore
  },
  watch: {
    messageContent (val) {
      if (val.indexOf('@') !== -1) {
        this.isAtWaiter = true
      } else {
        this.isAtWaiter = false
      }
    },
    getQuestionDetail (val) {
      this.isAllMessage = false
      this.currentPage = 0
    }
  }
}
</script>

<style scoped>
  .icon-player-pause {
    width: 15px;
    height: 15px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    position: absolute;
    background: url("~@/icons/icon-player-pause.png") no-repeat;
    background-size: 15px 15px;
    background-position: center;
  }
  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: #ccc;
  }
  ul, li {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  pre {
    padding: 0;
    margin: 0;
    width: 100%;
    font-size: 14px;
    color: #333333;
    overflow: hidden;
    font-family: 'Hiragino Sans GB', 'microsoft yahei', arial, sans-serif;
    line-height: 18px;
    letter-spacing: 0;
    white-space: pre-wrap; /*css-3*/
    white-space: -moz-pre-wrap; /*Mozilla,since1999*/
    white-space: -pre-wrap; /*Opera4-6*/
    white-space: -o-pre-wrap; /*Opera7*/
    word-wrap: break-word; /*InternetExplorer5.5+*/
  }
  #question-detail {
    /*width: 483px;*/
    width: calc(38% - 8px);
    overflow-x: hidden;
    overflow-y: scroll;
  }
  #question-detail::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0);
  }
  #question-detail:hover::-webkit-scrollbar-thumb {
    background-color: #ccc;
  }

  /* 问题详情 */
  .quiz {
    /*width: 481px;*/
    width: 100%;
    min-height: 273px;
  }

  .quiz-title {
    box-sizing: border-box;
    display: flex;
    /*width: 481px;*/
    width: 100%;
    min-height: 44px;
    margin-bottom: 2px;
    line-height: 22px;
    padding: 10px 0;
    background: #fff;
    box-shadow: inset 0 0 0 0 #E0E0E0;
  }
  .title-icon {
    margin-left: 16px;
    margin-top: 5px;
    width: 27px;
    height: 12px;
    border-radius: 2px;
    font-size: 10px;
    color: #FFFFFF;
    text-align: center;
    line-height: 12px;
    background: url("../../icons/questionIcon.svg") no-repeat;
    background-size: 27px 12px;
  }
  .title-text {
    flex: 1;
    padding-left: 8px;
    padding-right: 10px;
    font-size: 16px;
    color: #333333;
    letter-spacing: -0.39px;
    /*width: 418px;*/
    overflow: hidden;
    word-wrap: break-word;
  }

  .quiz-date {
    display: flex;
    justify-content: space-between;
    height: 44px;
    padding-left: 51px;
    margin-bottom: 2px;
    font-size: 12px;
    color: #333333;
    line-height: 44px;
    background: #fff;
    box-shadow: inset 0 0 0 0 #E0E0E0;
  }

  .quiz-date-left {
    display: flex;
  }
  .quiz-date-right {
    display: flex;
    padding-right: 12px;
  }
  .solving {
    display: flex;
    align-items: center;
  }
  .icon-solving {
    width: 12px;
    height: 12px;
    padding-right: 8px;
    background: url("../../icons/icon_solving_green.svg") no-repeat center center;
    background-size: 12px 12px;
  }
  .question-time {
    margin-bottom: 2px;
    box-shadow: inset 0 0 0 0 #E0E0E0;
  }

  .question-time span:nth-of-type(1) {
    margin-right: 6px;
    color: #777777;
  }

  .question-time span:nth-of-type(2) {
    margin-right: 18px;
  }

  .answer-time {
    /*width: 156px;*/
    /*margin-right: 24px;*/
  }

  .answer-time span:nth-of-type(1) {
    margin-right: 6px;
    color: #777777;
  }

  .answer-time span:nth-of-type(2) {
    /*margin-right: 34px;*/
  }

  .quiz-like {
    padding-left: 19px;
    color: #999999;
    background: url("../../icons/check-mark-gray.svg") no-repeat left center;
  }

  .quiz-detail {
    box-sizing: border-box;
    display: flex;
    min-height: 181px;
    padding: 16px 12px 10px 16px;
    line-height: 22px;
    background: #fff;
    overflow: hidden;
    word-wrap: break-word;
  }

  .detail-icon {
    width: 29px;
    height: 14px;
    border-radius: 2px;
    margin-top: 2px;
    margin-right: 9px;
    font-size: 10px;
    color: #777777;
    line-height: 14px;
    text-align: center;
    letter-spacing: -0.24px;
    background: #EFEFEF;
  }

  .detail-content {
    flex: 1;
    overflow: hidden;
    /*width: 415px;*/
  }
  .detail-text {
    /*width: 415px;*/
    flex: 1;
    margin: 0;
    font-size: 14px;
    color: #333333;
    line-height: 18px;
    letter-spacing: 0;
    overflow: hidden;
  }

  .annex-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    margin-bottom: 12px;
    position: relative;
  }
  .annex-item {
    width: 50px;
    height: 50px;
    margin-left: 5px;
    margin-top: 5px;
    cursor: pointer;
    position: relative;
  }
  .annex-list img {
    flex-shrink: 0;
    width: 50px;
    height: 50px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
  }

  /* 提问 */
  .reply {
    /*width: 481px;*/
    width: 100%;
    margin-top: 12px;
    background: #fff;
  }

  .reply-input {
    display: flex;
    justify-content: center;
  }

  .reply-input input {
    box-sizing: border-box;
    width: 460px;
    height: 41px;
    padding: 0 10px;
    border: 1px solid #CCCCCC;
    border-radius: 4px;
    margin-top: 15px;
    font-size: 14px;
  }
  .reply-input textarea {
    box-sizing: border-box;
    width: 460px;
    height: 44px;
    padding: 6px 10px;
    border: 1px solid #CCCCCC;
    border-radius: 4px;
    margin-top: 15px;
    font-size: 14px;
    resize: none;
  }
  .editor {
    box-sizing: border-box;
    width: 460px;
    min-height: 44px;
    padding: 6px 10px;
    border: 1px solid #CCCCCC;
    outline: none;
    border-radius: 4px;
    margin-top: 15px;
    font-size: 14px;
    line-height: 18px;
    resize: none;
    user-modify: read-write-plaintext-only;
    -webkit-user-modify: read-write-plaintext-only;
  }

  .submit {
    display: flex;
    justify-content: space-between;
    /*width: 460px;*/
    width: 95%;
    padding: 15px 0;
    margin: 0 auto;
  }

  .upload-wrap {
    position: relative;
  }
  .upload {
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
    width: 94px;
    height: 26px;
    padding-left: 29px;
    font-size: 14px;
    color: #777777;
    line-height: 26px;
    border-radius: 4px;
    letter-spacing: -0.34px;
    background: #EFEFEF url("../../icons/upload-image.svg") no-repeat 7px 5px;
    cursor: pointer;
  }
  .picture-count {
    position: absolute;
    top: 0;
    left: 100px;
    width: 60px;
    height: 26px;
    color: #030303;
    line-height: 26px;
  }

  .submit-input {
    width: 50px;
    height: 26px;
    border-radius: 4px;
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
    line-height: 26px;
    letter-spacing: -0.34px;
    background: #4A90E2;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/question-detail/question-detail.vue